import ShoppingLists from 'global/shoppingLists/ShoppingLists';
import Ajax from 'global/od/Ajax';
import * as globalUtils from 'global/common/globalUtils';

const { FormControl } = window.od;

export default class SwitchAndSave {
	constructor() {
		this.products = document.querySelectorAll('[data-switch-active=true]');

		if (this.products.length) {
			this.triggerSetup();
		}
	}

	triggerSetup() {
		for (let i = 0; i < this.products.length; i += 1) {
			this.attachEvent(i);
		}
	}

	attachEvent(index) {
		this.products[index].addEventListener('click', e => {
			const button = e.target.closest('[data-switch-sku]');

			if (button) {
				const sku = button.getAttribute('data-switch-sku');

				if (!sku) {
					return;
				}

				e.preventDefault();
				this.productPanel = e.currentTarget;
				this.switchButton = e.target.closest('a');

				if (this.switchButton.getAttribute('switch-product-ready') === 'true') {
					this.showSwitchProduct();
				} else {
					this.addSwitchProduct();
				}

				window.od.events.publish('switchAndSave_Click', {
					url: window.location.href,
					sku,
				});
			}
		});
	}

	addSwitchProduct() {
		const targetSku = this.switchButton.getAttribute('data-switch-sku');

		return this.getSwitchProduct(targetSku).then(result => {
			const { data } = result;

			this.attachProduct(data);
		});
	}

	attachProduct(data) {
		const responseHtml = globalUtils.getNodeFromString(data);

		this.productWrapper = this.productPanel.parentElement;
		this.productWrapper.appendChild(responseHtml);
		this.switchButton.setAttribute('switch-product-ready', true);

		this.switchProduct = this.productWrapper.querySelector('.product-overlay');

		if (this.switchProduct) {
			this.attachProductActions();
			this.showSwitchProduct();
			this.attachClose();

			window.od.events.publish('switchAndSave_Switched', {
				element: this.switchProduct,
			});
		}
	}

	attachProductActions() {
		const switchProductForm = this.switchProduct.querySelectorAll(
			'[data-validation="true"]',
		)[0];

		if (switchProductForm) {
			new FormControl(switchProductForm);
			new ShoppingLists();
		}
	}

	attachClose() {
		this.switchProduct.addEventListener('click', e => {
			if (e.target.getAttribute('data-product-overlay') === 'true') {
				this.hideSwitchProduct(e.currentTarget);
			}
		});
	}

	showSwitchProduct() {
		const el = this.getTargetElements();

		el.switchProduct.classList.remove('d-none');
		el.defaultProduct.classList.add('invisible');
	}

	hideSwitchProduct(target) {
		const el = this.getTargetElements(target);

		el.switchProduct.classList.add('d-none');
		el.defaultProduct.classList.remove('invisible');
	}

	getTargetElements(target = this.productPanel) {
		const elements = {
			switchProduct: target.parentElement.querySelector('.product-overlay'),
			defaultProduct: target.parentElement.querySelector(
				'.product-lister-item',
			),
		};

		return elements;
	}

	getSwitchProduct(sku) {
		return Ajax.get('/ajax/product-overlay', {
			sku,
		});
	}
}
